<mat-drawer-container class="menu-container">

  <mat-drawer #sideMenu [mode]="'over'" class="side-menu">
    <side-menu [isLoggedIn]="isLoggedIn()" [isGuest]="isGuest()" [role]="roleSignal()"
      (menuEvent)="incomingSideMenuEvent($event)"></side-menu>
  </mat-drawer>

  <mat-drawer-content class="main-content">
    <!-- main menu bar-->
    <main-menu [isLoggedIn]="isLoggedIn()" [role]="roleSignal()"
      (mainMenuEvent)="incomingMainMenuEvent($event)"></main-menu>
    <div class="spacer"></div>



    <div class="main-view" [style.display]="loading() ? 'block' : 'none'">
      <loading-screen></loading-screen>
    </div>

    <div class="main-view" [style.display]="!loading() ? 'block' : 'none'">
      <div class="online-status" *ngIf="!isOnline()">
        <p>offline</p>
      </div>

      <div class="online-status" *ngIf="isLoggedIn() && isOnline()">
        <mat-icon class="connection-status" *ngIf="isConnected()">wifi</mat-icon>
        <mat-icon class="connection-status" *ngIf="!isConnected()">wifi_off</mat-icon>
      </div>


      <chat-box *ngIf="isLoggedIn() && activeInstance()" [isConnected]="isConnected()" [isLive]="true"></chat-box>

      <router-outlet></router-outlet>


    </div>



  </mat-drawer-content>
</mat-drawer-container>